<template>
  <div>
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <!-- Card -->
        <div class="card mt-5">
          <!-- Header -->
          <div class="card-header border-bottom-0 pb-0">
            <div class="row align-items-center">
              <div class="col">
                <!-- Title -->
                <h4 class="card-header-title mb-0">Course Completion Mitra Report - HSE Admin</h4>
              </div>
            </div>
          </div>

          <div class="p-4">
            <!-- Period Selection -->
            <div class="row mb-4">
              <div class="col-lg-4">
                <label class="form-label">Period :</label>
                <v-select
                  v-model="selectedPeriod"
                  :options="periodOptions"
                  :reduce="option => option.value"
                  label="label"
                  placeholder="Please select"
                  :clearable="false"
                  :loading="periodsLoading"
                >
                </v-select>
              </div>
              <div v-if="isHSERole" class="col-lg-4">
                <label class="form-label">Company :</label>
                <v-select
                  v-model="filters.company"
                  :options="companyOptions"
                  placeholder="All Company"
                  :clearable="true"
                  :loading="companiesLoading"
                />
              </div>
            </div>

            <!-- History and This Year Section -->
            <div class="row mb-4">
              <!-- History Section -->
              <div class="col-md-6">
                <h5 class="mb-3">History</h5>
                <div class="progress mb-2" style="height: 25px;">
                  <div 
                    class="progress-bar bg-primary" 
                    role="progressbar" 
                    :style="`width: ${summary.history.percentage}%;`" 
                    :aria-valuenow="summary.history.percentage" 
                    aria-valuemin="0" 
                    aria-valuemax="100"
                  >
                    {{ summary.history.percentage }}%
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-warning">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-target"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Plan</p>
                        <h3 class="mb-0">{{ summary.history.submitted }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-teal">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-check-circle"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Approved</p>
                        <h3 class="mb-0">{{ summary.history.approved }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-success">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-check"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Completed</p>
                        <h3 class="mb-0">{{ summary.history.completed }}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- This Year Section -->
              <div class="col-md-6">
                <h5 class="mb-3">This Year</h5>
                <div class="progress mb-2" style="height: 25px;">
                  <div 
                    class="progress-bar bg-success" 
                    role="progressbar" 
                    :style="`width: ${summary.this_year.percentage}%;`" 
                    :aria-valuenow="summary.this_year.percentage" 
                    aria-valuemin="0" 
                    aria-valuemax="100"
                  >
                    {{ summary.this_year.percentage }}%
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-warning">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-target"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Plan</p>
                        <h3 class="mb-0">{{ summary.this_year.submitted }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-teal">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-check-circle"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Approved</p>
                        <h3 class="mb-0">{{ summary.this_year.approved }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-success">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-check"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Completed</p>
                        <h3 class="mb-0">{{ summary.this_year.completed }}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- All Course Section -->
          <div class="card-body pt-2">
            <!-- Filter Bar -->
            <div class="row align-items-center mb-4">
              <div class="col-md-2">
                <h6 class="mb-0 font-weight-bold">Course Report</h6>
              </div>
              <div class="col-md-10">
                <div class="d-flex justify-content-end align-items-center gap-2">
                  <div style="width: 250px;">
                    <input
                      type="text"
                      v-model="filters.search"
                      class="form-control form-control-sm"
                      placeholder="Search Course..." />
                  </div>
                </div>
              </div>
            </div>

            <!-- Loading State -->
            <div v-if="isLoading" class="text-center py-5">
              <div class="spinner-border text-danger" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <p class="mt-2 text-muted">Loading course data...</p>
            </div>

            <!-- Empty State -->
            <div v-else-if="paginatedCourses.length === 0" class="text-center py-5">
              <i class="fe fe-inbox" style="font-size: 3rem; color: #dee2e6;"></i>
              <p class="mt-3 text-muted">No courses found</p>
            </div>

            <!-- Cards Grid -->
            <div v-else class="row">
              <div class="col-lg-3 col-md-6 col-sm-12 mb-4" v-for="course in paginatedCourses" :key="course.id">
                <div @click="viewCourseDetail(course)" style="cursor: pointer;" class="card h-100 shadow-sm border course-card">
                  <!-- Card Image/Thumbnail -->
                  <div class="position-relative">
                    <img 
                      :src="course.cover_image_path ? `${imageBaseUrl}/attachments/${course.cover_image_path}` : 'https://dummyimage.com/300x200/FAFAFA/000000&text=Course'" 
                      :alt="course.title"
                      class="card-img-top"
                      style="height: 150px; object-fit: cover;"
                      @error="handleImageError">
                    
                    <!-- Status Badge -->
                    <div class="position-absolute" style="top: 8px; left: 8px;">
                      <span :class="getStatusBadgeClass(course.tna_status)">
                        {{ formatStatus(course.tna_status) }}
                      </span>
                    </div>

                    <!-- Type Badge (Top Right) -->
                    <div class="position-absolute" style="top: 8px; right: 8px;">
                      <span :class="getTypeBadgeClass(course.training_type)">
                        {{ formatType(course.training_type) }}
                      </span>
                    </div>
                  </div>
                  
                  <!-- Card Body -->
                  <div class="card-body p-3">
                    <!-- Badges Row -->
                    <div class="mb-2 d-flex flex-wrap gap-1">
                      <span class="badge-icon bg-danger-soft text-danger">
                        <i :class="getTrainingTypeIcon(course.training_type)" style="font-size: 10px;"></i>
                      </span>
                      <span class="badge-custom bg-warning-soft text-warning">
                        {{ course?.role_competency || '-' }}
                      </span>
                      <span class="badge-custom bg-info-soft text-info">
                        {{ course?.role_competency_type || '-' }}
                      </span>
                    </div>
                    
                    <!-- Course Title -->
                    <h6 class="card-title font-weight-bold mb-2" style="font-size: 0.9rem; line-height: 1.3; min-height: 36px;">
                      {{ course.title }}
                    </h6>

                    <!-- Provider -->
                    <p class="card-text text-muted mb-2" style="font-size: 0.75rem;">
                      <i class="fe fe-briefcase me-1"></i>
                      {{ course.provider_name }}
                    </p>
                  </div>
                  
                  <!-- Card Footer -->
                  <div class="card-footer bg-white border-top px-3 py-2">
                    <div class="d-flex justify-content-between align-items-center">
                      <!-- Left: Duration & Platform -->
                      <div class="d-flex gap-3">
                        <div class="d-flex align-items-center">
                          <i class="fe fe-clock text-muted me-1" style="font-size: 0.85rem;"></i>
                          <small class="text-muted" style="font-size: 0.75rem;">{{ course.hour }}h</small>
                        </div>
                        <div class="d-flex align-items-center">
                          <i class="fe fe-monitor text-muted me-1" style="font-size: 0.85rem;"></i>
                          <small class="text-muted" style="font-size: 0.75rem;">{{ course.platform }}</small>
                        </div>
                      </div>
                      
                      <!-- Right: Action Buttons -->
                      <div class="d-flex gap-1" >
                        <!-- Download Certificate Button (for completed) -->
                        <button 
                          @click.stop
                          v-if="course.status === 'completed' && course.certificate_path"
                          class="btn btn-sm btn-outline-success"
                          @click="downloadCertificate(course)"
                          title="Download Certificate">
                          <i class="fe fe-download" style="font-size: 0.8rem;"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Pagination -->
            <div v-if="totalPages > 1" class="d-flex justify-content-between align-items-center mt-4">
              <div>
                <small class="text-muted">
                  Showing {{ (currentPage - 1) * perPage + 1 }} to {{ Math.min(currentPage * perPage, totalItems) }} of {{ totalItems }} entries
                </small>
              </div>
              <nav>
                <ul class="pagination pagination-sm mb-0">
                  <li class="page-item" :class="{ disabled: currentPage === 1 }">
                    <button class="page-link" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">
                      <i class="fe fe-chevron-left"></i>
                    </button>
                  </li>
                  <li 
                    v-for="page in visiblePages" 
                    :key="page"
                    class="page-item" 
                    :class="{ active: currentPage === page, disabled: page === '...' }">
                    <button 
                      v-if="page === '...'" 
                      class="page-link" 
                      disabled>
                      ...
                    </button>
                    <button 
                      v-else
                      class="page-link" 
                      @click="changePage(page)">
                      {{ page }}
                    </button>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                    <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">
                      <i class="fe fe-chevron-right"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modals -->
    <modal-course-detail 
      :selectedCourse="selectedCourse"
      :idpPeriod="selectedPeriod"
      :company="filters.company"
      @download-certificate="downloadCertificate"
      @completion-reviewed="handleCompletionReviewed"
    />
  </div>
</template>

<script>
import logic from './course-completion-mitra-report.logic.js';
import ModalCourseDetail from './components/modal-course-detail.vue';

export default {
  ...logic,
  components: {
    ModalCourseDetail
  },
};
</script>

<style src="./course-completion-mitra-report.css" scoped></style>
